import { Dom, animate } from '@brandocms/jupiter'

export default _app => ({
  logoColor: '#000',
  logoPathSelector: 'svg path',
  contentSelector: 'section.main',
  hamburgerColor: '#000',

  onResize: m => {
    if (document.body.classList.contains('open-menu')) {
      m.bg.style.height = `${window.innerHeight}px`
    }
  },

  openTween: async m => {
    const menuButton = Dom.find('.menu-button')
    menuButton.classList.toggle('is-active')
    m.hamburger.classList.toggle('is-active')
    document.body.classList.toggle('open-menu')

    // set hamburger text
    const hamburgerTextEl = Dom.find(m.hamburger, 'span')
    const newText = m.hamburger.dataset.closeText
    hamburgerTextEl.innerHTML = newText

    m.bg.style.display = 'block'
    await animate(m.bg, { x: 0 }, { duration: 0.4, ease: [0.455, 0.03, 0.515, 0.955] })
    m._emitMobileMenuOpenEvent()
  },

  closeTween: async m => {
    const menuButton = Dom.find('.menu-button')

    // set hamburger text
    const hamburgerTextEl = Dom.find(m.hamburger, 'span')
    const newText = m.hamburger.dataset.openText
    hamburgerTextEl.innerHTML = newText

    m._emitMobileMenuClosedEvent()
    document.body.classList.toggle('open-menu')
    m.hamburger.classList.toggle('is-active')
    menuButton.classList.toggle('is-active')

    await animate(m.bg, { x: '-100%' }, { duration: 0.4, ease: [0.455, 0.03, 0.515, 0.955] })
    m.bg.style.display = 'none'
  },
})
